import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';

import classes from './DateTime.module.css';

const DateTime = (props) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DesktopDatePicker
        value={props.startDate || null}
        label="Start Time"
        // toolbarFormat="ddd DD MMMM"
        onChange={props.onStartDateChange}
        renderInput={(params) => <TextField {...params} />}
        className={classes.date}
        disableFuture={true}
      />
      <DesktopDatePicker
        value={props.endDate || null}
        label="End Time"
        onChange={props.onEndDateChange}
        renderInput={(params) => <TextField {...params} />}
        className={classes.date}
        disableFuture={true}
      />
    </LocalizationProvider>
  );
};

export default DateTime;